<template>
    <div>
        <v-card color="#00ACC1" elevation="0" height="100px" class="d-flex align-content-end">
            <v-card-title class="white--text text-h5">
                <v-icon color="white" large>mdi-account-circle-outline</v-icon>
                &nbsp;My Profile
            </v-card-title>
        </v-card>
        <Profile />
    </div>
</template>
<script>
import Profile from "../../../components/Applicants/Profile/Profile.vue"
export default {
    components: {
        Profile
    }
    
}
</script>